import { render, staticRenderFns } from "./ShipExperience.vue?vue&type=template&id=097fb283&scoped=true"
import script from "./ShipExperience.vue?vue&type=script&lang=js"
export * from "./ShipExperience.vue?vue&type=script&lang=js"
import style0 from "./ShipExperience.vue?vue&type=style&index=0&id=097fb283&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097fb283",
  null
  
)

export default component.exports